"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Cut string for the given length and append ... if string is larger than the given length
*
*/
function readMoreChars(string, length, readMoreDots) {
    if (readMoreDots === void 0) { readMoreDots = '...'; }
    if (string.length <= length)
        return string;
    return string.substring(0, length) + readMoreDots;
}
exports.default = readMoreChars;
;
//# sourceMappingURL=readMoreChars.js.map